import {Endpoint} from "./BaseEndpoint";

export class PeriodsEndpoint extends Endpoint {
    constructor() {
        super("periods");
    }
}
